import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SanitizerPipe } from '../../pipes';
import { CurrentFacilityService, CustomerServiceInfo } from '../../services/current-facility.service';

@Component({
    selector: 'app-customer-service',
    standalone: true,
    imports: [SanitizerPipe],
    templateUrl: './customer-service.component.html',
    styleUrl: './customer-service.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class CustomerServiceComponent implements OnInit {
    public customerServiceInfo: CustomerServiceInfo | null = null;

    constructor(private currentFacilityService: CurrentFacilityService) {}

    ngOnInit(): void {
        this.getCustomerServiceInfo();
    }

    getCustomerServiceInfo(): void {
        this.customerServiceInfo = this.currentFacilityService.getCustomerServiceInfo();
    }
}
